import React from 'react'
import { Layout, Typography, Button } from 'antd'
import { MenuOutlined, LogoutOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Header: AntHeader } = Layout
const { Title, Text } = Typography

interface HeaderProps {
  isMobile?: boolean
  sidebarCollapsed?: boolean
  onToggleSidebar?: () => void
}

const Header: React.FC<HeaderProps> = ({
  isMobile = false,
  sidebarCollapsed = false,
  onToggleSidebar
}) => {
  const navigate = useNavigate()

  const handleLogout = () => {
    localStorage.removeItem('kredit_api_key')
    navigate('/login', { replace: true })
  }

  return (
    <AntHeader
      className="kredit-header"
      style={{
        padding: isMobile ? '0 12px' : '0 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', minWidth: 0 }}>
        {/* Menu button for mobile/collapsed sidebar */}
        {(isMobile || sidebarCollapsed) && (
          <Button
            type="text"
            icon={<MenuOutlined style={{ color: 'white', fontSize: '20px' }} />}
            style={{
              border: 'none',
              boxShadow: 'none',
              marginRight: '8px',
              padding: '4px 8px'
            }}
            onClick={onToggleSidebar}
          />
        )}

        <Title
          level={3}
          style={{
            color: 'white',
            margin: 0,
            fontSize: isMobile ? '16px' : '20px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          CreditFlow AI - Dashboard
        </Title>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {!isMobile && (
          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13 }}>
            Panel operativo
          </Text>
        )}
        <Button
          type="text"
          icon={<LogoutOutlined style={{ color: 'rgba(255,255,255,0.75)' }} />}
          onClick={handleLogout}
          title="Cerrar sesión"
          style={{ border: 'none', boxShadow: 'none', padding: '4px 8px' }}
        />
      </div>
    </AntHeader>
  )
}

export default Header